import { getJSON } from '@folklore/fetch';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

const usePage = (path, { query = null, ...config } = {}) => {
    const key = ['pages', path, query];

    const {
        data: page = null,
        status = null,
        isLoading = false,
        isError = false,
        isFetching = false,
        refetch = null,
        ...otherProps
    } = useQuery({
        queryKey: key,
        queryFn: ({ queryKey: [, pathname] }) =>
            getJSON(
                `${pathname === '/' ? 'home' : pathname}.json${
                    !isEmpty(query)
                        ? `?${queryString.stringify(query, { arrayFormat: 'bracket' })}`
                        : ''
                }`,
            ),
        suspense: false,
        retry: 1,
        placeholderData: keepPreviousData,
        ...config,
    });

    return {
        ...otherProps,
        page,
        isLoading,
        isError,
        status,
        loading: !isError && (isFetching || isLoading),
        refetch,
    };
};

export default usePage;
